import ReleaseFlag from 'api/legacy/releaseFlags/enumReleaseFlags';
import useSimDetails from 'api/sims/useSimDetails';
import useSimStatuses from 'api/sims/useSimStatuses';
import useUserInfo from 'hooks/User/useUserInfo';
import { useCallback, useMemo } from 'react';
import type { DropdownItemEntry, ManageSimItemHook } from '../types';

const useSetDataUsageAlert: ManageSimItemHook = ({
  context,
  selectedSims,
  disabled,
  handleModalOpen,
  onSimsModified,
  onActionTaken,
}) => {
  const onClick = useCallback(() => {
    handleModalOpen({
      modalName: 'SetUsageAlertsModal',
      modalProps: { sims: selectedSims, onModalSuccess: onSimsModified },
    });
    onActionTaken();
  }, [onActionTaken, handleModalOpen, onSimsModified, selectedSims]);

  const simId = context === 'details' && selectedSims ? [...selectedSims.keys()][0] : undefined;
  const { simDetails } = useSimDetails(simId);

  const { networkStatusGroups } = useSimStatuses();

  const { organizationRole, releaseFlags } = useUserInfo();

  const hasDataUsageAlerts = releaseFlags.has(ReleaseFlag.FEATURE_DATA_USAGE_ALERTS);

  const show =
    ['admin', 'manager', 'editor'].includes(organizationRole) &&
    hasDataUsageAlerts &&
    (networkStatusGroups?.deactivated?.findIndex(
      (state) => simDetails.networkStatus?.localeCompare(state) === 0
    ) ?? -1) === -1;

  return useMemo<DropdownItemEntry | false>(
    () =>
      show && {
        id: `sim${context}-datausagelimits-updatealert`,
        disabled,
        iconStart: 'Warning',
        children: 'Set data usage alert...',
        onClick,
      },
    [context, disabled, onClick, show]
  );
};

export default useSetDataUsageAlert;
